export default __webpack_public_path__ + "static/media/CIHE_Composicion_sola3.effabd4a.jpg";